import useAuth from "../../hooks/useAuth";
import {useEffect} from "react";

export default function CheckRole(props) {

    const {roles} = props

    const {logout, auth} = useAuth()

    useEffect(() => {
        if (roles) {
            if (!roles.includes("ROLE_PUBLIC")) {
                if (!roles.includes(auth?.primaryUser?.role) && !roles.includes(auth?.secondaryUser?.role)) {
                    logout()
                }
            }

        }
    })

    return(<></>)
}
